import { RoleService } from "services/role.service";
import { IRole } from "models/RoleModel";
import { InternalUserService } from "services/InternalUser/internalUser.service";
import { IUserStatus } from "models/InternalUser/UserStatusModel";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Shared } from "utility/shared";
import { RootState } from "./store";
import { ITitle } from "models/TitleModel";
import { UserTitleService } from "services/userTitle.service";
import { UserService } from "services/user.service";
import { IUser } from "models/InternalUser/UserModel";

export interface InternalUserState {
	userTitle: ITitle[];
	internalUserStatusList: IUserStatus[];
	roleList: IRole[];
	userList: IUser[];
}

const initialState: InternalUserState = {
	userTitle: [],
	internalUserStatusList: [],
	roleList: [],
	userList: [],
};

export const fetchUserTitleList = createAsyncThunk(
	"getUserTitleList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.internalUserState.userTitle.length === 0) {
			return await UserTitleService.getTitleList();
		}
	}
);

export const fetchInternalUserStatusList = createAsyncThunk(
	"getInternalUserStatusList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.internalUserState.internalUserStatusList.length === 0) {
			return await InternalUserService.getUserStatusList();
		}
	}
);

export const fetchInternalUserRoleList = createAsyncThunk(
	"getInternalUserRoleList",
	async (isForceAPICall: boolean, { getState }) => {
		const state = getState() as RootState;
		if (state.internalUserState.roleList.length === 0 || isForceAPICall) {
			return await RoleService.getRoleList();
		}
	}
);

export const fetchInternalUserList = createAsyncThunk(
	"getUserList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.internalUserState.userList.length === 0) {
			return await UserService.getInternalUsers();
		}
	}
);

export const internalUserStateSlice = createSlice({
	name: "InternalUserState",
	initialState,
	reducers: {},
	extraReducers: {
		[fetchUserTitleList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.userTitle = action.payload;
			}
		},
		[fetchUserTitleList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading User Title List, please try again!"
			);
		},
		[fetchInternalUserStatusList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.internalUserStatusList = action.payload;
			}
		},
		[fetchInternalUserStatusList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading internal User Status List, please try again!"
			);
		},
		[fetchInternalUserRoleList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.roleList = action.payload;
			}
		},
		[fetchInternalUserRoleList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading internal User Role List, please try again!"
			);
		},
		[fetchInternalUserList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.userList = action.payload;
			}
		},
		[fetchInternalUserList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage("Error loading user list, please try again!");
		},
	},
});

export default internalUserStateSlice.reducer;
